import events from '../dom/modules/events.js';
import delegate from '../dom/modules/delegate.js';
import { get, set, remove, push, contains } from "../dom/modules/storage.js";
import { requestPostCollections } from './collections.js';

events('click', document).each(delegate({
    'button[name="toggle-favourites"]': function(button, e) {
        e.preventDefault();
        const favourites = localStorage.getItem("favourites") || '{"uuid": "", "objects": []}';
        let key = button.dataset.id;
        let type = button.dataset.type;
        let data = {}
        data[type] = key;
        if (favourites && JSON.parse(favourites).uuid) {
            data.collection = JSON.parse(favourites).uuid;
        }

        let res = requestPostCollections(data);
        res.then(collections => {
            if (collections.length) {
                let newFavourites = { uuid: collections[0].uuid };
                localStorage.setItem("favourites", JSON.stringify(newFavourites));
            }
        })
        .catch((error) => {
            // console.error('Error:', error);
        });

        return;
    }
}));

export function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

function addToFavourites(id){
    if (contains("favourites", id)) {
        removeFromFavourites(id)
    }
    push("favourites", id)
}

function removeFromFavourites(id) {
    if (!contains("favourites", id)) {
        addToFavourites(id);
    }
    remove("favourites", id)
}
